'use client';

import { useFirstPageInteraction } from '@/hooks/auth/use-first-page-interaction';
import { useHasAuthSessionHint } from '@/hooks/auth/use-has-auth-session-hint';
import { useAuthSessionObserver } from '@/lib/auth/auth-session-observer';
import dynamic from 'next/dynamic';

function shouldSkipOneTapForAutomation() {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || '';
  return (
    navigator.webdriver === true ||
    /Chrome-Lighthouse|Lighthouse|Page Speed|HeadlessChrome/i.test(userAgent)
  );
}

const GoogleOneTap = dynamic(
  () =>
    import('@/components/auth/shell/google-one-tap').then(
      (mod) => mod.GoogleOneTap
    ),
  { ssr: false }
);

export function DeferredGoogleOneTap() {
  const { hasInteracted } = useFirstPageInteraction();
  const hasAuthSessionHint = useHasAuthSessionHint({
    enabled: hasInteracted,
  });
  const authSession = useAuthSessionObserver();
  const skippedForAutomation = shouldSkipOneTapForAutomation();
  const shouldWaitForAuthResolution =
    hasAuthSessionHint &&
    (authSession.status === 'idle' || authSession.status === 'loading');
  const shouldSkipBecauseAuthenticated = authSession.status === 'authenticated';

  if (!hasInteracted) return null;
  if (skippedForAutomation) return null;
  if (shouldSkipBecauseAuthenticated) return null;
  if (shouldWaitForAuthResolution) return null;

  return <GoogleOneTap />;
}
